<template>
    <div class="text-input">
        <div :style="injectCSSVariable()">
            <b-form-input
                v-if="isNumberType"
                :disabled="disabled" 
                @input="handleChange"
                :v-model="text"
                :placeholder="placeholder"
                :state="validationHandler"
                aria-describedby="input-feedback"
                :formatter="formatter"
                v-numeric-only
            />
            <b-form-input
                v-else-if="isPhoneType"
                :disabled="disabled" 
                @input="handleChange"
                :v-model="text"
                :placeholder="placeholder"
                :state="validationHandler"
                aria-describedby="input-feedback"
                v-phone
            />
            <b-form-input
                v-else
                :disabled="disabled" 
                @input="handleChange"
                :v-model="text"
                :placeholder="placeholder"
                :state="validate ? validationHandler : null"
                aria-describedby="input-feedback"
            />
            <b-form-invalid-feedback id="input-feedback">
                {{ validationFeedback }}
            </b-form-invalid-feedback>
        </div>
        
    </div>
</template>
<script>
import colorVariantMixin from '@/components/mixins/colorVariantMixin'

export default {
    name: 'textInput',
    mixins: [
        colorVariantMixin
    ],
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: '',
        },
        textType: {
            type: String,
            default: 'text'
        },
        validate: {
            type: Boolean,
            default: true
        },
        validator: {
            type: Function,
            default: () => true
        },
        errorText: {
            type: String
        },
        locale: {
            type: Object
        },
        format: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        validationHandler() {

            if(this.text === null) {
                return null
            }
            return this.validator(this.text)
        },
        validationFeedback() {
            return this.errorText || 'Invalid Input'
        },
        isNumberType() {
            return this.textType === 'number'
        },
        isPhoneType() {
            return this.textType === 'phone'
        }
    },
    data() {
        return {
            text: null,
        }
    },
    methods: {
        handleChange(input) {
            if(this.isNumberType) {        
                // safety for numbers with spaces (allowed in french)
                input = input.replace(/\s/g, '');
                input = parseInt(input.split(this.locale.thousands).join(''))
            }
            this.text = input

            if(this.validationHandler) {
                this.$emit('change', input)
            }
            if(!this.validationHandler) {
                this.$emit('change', null)
            }
        },
        formatter(value) {
            // safety for numbers with spaces (allowed in french)
            value = value.replace(/\s/g, '');
            if(this.format && this.isNumberType && value !== '') {
                const parsedNumber = parseInt(value.split(this.locale.thousands).join(''))
                if(!isNaN(parsedNumber)) {
                    return parsedNumber.toLocaleString(this.locale.tag)
                }
            }

            return value
        },
        injectCSSVariable() {
            return {
                '--variant': this.baseColor,
                '--variant-light': this.baseColorLight 
            };
        }
    },
    directives: {
        'numeric-only': {
            inserted: function (el) {
                el.addEventListener('keyup', () => {
                    // Allow digits, commas, periods, minus signs, and spaces
                    const regex = /^[0-9.,\s-]*$/;

                    if (!regex.test(el.value)) {
                        // Remove everything that's NOT allowed
                        el.value = el.value.replace(/[^0-9.,\s-]/g, '');
                    }
                });
            }
        },
        'phone': {
            inserted: function (el) {
                el.addEventListener('keyup', () => {
                    const regex = /^[0-9.,+]*$/
                    if (!regex.test(el.value)) {
                        el.value = el.value.replace(/[a-zA-Z]*/, '')
                        el.value = el.value.slice(0, -1)
                    }
                })
            }
        }
    }
}
</script>
<style lang="scss">
    input[type="text"]:focus {
        border-color: var(--variant);
        outline: 0;
        -webkit-box-shadow: none; //inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px var(--variant-light);
        box-shadow: none; // inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px var(--variant-light);
    }

    .text-input {
        min-height: 62px;
    }
</style>